/**
 * 刷新菜单 代办数量
 * @export
 * @author Hanger Zou
 */
export function freshMenu() {
  this.$fetch('/fesback/cpmpMenu/getMenuTodoNum.z', {}).then(res => {
    this.$store.commit('setMenuTodo', res.data)
    // console.log('刷新菜单', this.$store.state.menuState.menuTodo)
    // this.$store.commit('clearMenu')
    // this.$store.commit('setMenu', res)
  })
}
